import AxiosInstance from "../services/networkServices";

/** Installs linked to `minAccounts`+ accounts, with votes exchanged inside each cluster. */
export const getDeviceClusters = async ({ page = 1, limit = 20, minAccounts = 2 } = {}) => {
  const response = await AxiosInstance.get("/admin/anti-cheat/device-clusters", {
    params: { page, limit, minAccounts },
  });
  return response.data;
};

/** Nightly scan reports (users receiving votes from device-linked accounts). */
export const getFlaggedUsers = async ({ page = 1, limit = 20, flaggedOnly = true } = {}) => {
  const response = await AxiosInstance.get("/admin/anti-cheat/flagged-users", {
    params: { page, limit, flaggedOnly },
  });
  return response.data;
};

/** Vote attempts refused by the device rules. */
export const getBlockedVotes = async ({ page = 1, limit = 20, userId } = {}) => {
  const response = await AxiosInstance.get("/admin/anti-cheat/blocked-votes", {
    params: { page, limit, ...(userId && { userId }) },
  });
  return response.data;
};

/** Devices, linked accounts, linked votes and IP overlap for one user. */
export const getUserAntiCheatProfile = async (userId) => {
  const response = await AxiosInstance.get(`/admin/anti-cheat/user/${userId}`);
  return response.data;
};

/** Run the nightly scan now. */
export const runAntiCheatScan = async () => {
  const response = await AxiosInstance.post("/admin/anti-cheat/scan");
  return response.data;
};
